import { Box, Typography } from '@mui/joy';

// Брендинг банков: цвет + (опц.) inline SVG-логотип / эмодзи-плейсхолдер
export const BANKS = {
    alpha:      { name: 'Альфа Банк',  color: '#EF3124', textColor: '#fff' },
    sber:       { name: 'Сбер',         color: '#21A038', textColor: '#fff' },
    tinkoff:    { name: 'Т-Банк',       color: '#FFDD2D', textColor: '#000' },
    vtb:        { name: 'ВТБ',          color: '#0A2973', textColor: '#fff' },
    gazprom:    { name: 'Газпромбанк',  color: '#0079C2', textColor: '#fff' },
    raiffeisen: { name: 'Райффайзен',   color: '#FEDF00', textColor: '#000' },
    opening:    { name: 'Открытие',     color: '#00BFFF', textColor: '#fff' },
    sovcombank: { name: 'Совкомбанк',   color: '#D52127', textColor: '#fff' },
    ozon:       { name: 'Озон Банк',    color: '#005BFF', textColor: '#fff' },
    akbars:     { name: 'Ак Барс Банк', color: '#00A859', textColor: '#fff' },
    other:      { name: 'Банк',         color: '#6B7280', textColor: '#fff' },
};

/**
 * Эмблема банка: цветной квадратик с инициалами банка.
 * Можно заменить на настоящие SVG-логотипы — пока компромисс по простоте.
 */
export function BankBadge({ bank, size = 22 }) {
    const meta = BANKS[bank] || BANKS.other;
    const initial = meta.name.charAt(0);
    return (
        <Box sx={{
            width: size, height: size,
            borderRadius: '50%',
            bgcolor: meta.color,
            color: meta.textColor,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontWeight: 800,
            fontSize: size * 0.5,
            flexShrink: 0,
            boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
        }}>
            {initial}
        </Box>
    );
}

/**
 * Форматирует "79990777777" → "+7 (999) 077-77-77"
 */
export function formatPhone(phone) {
    if (!phone) return '';
    const digits = String(phone).replace(/\D/g, '');
    if (digits.length === 11 && digits.startsWith('7')) {
        return `+7 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7, 9)}-${digits.slice(9, 11)}`;
    }
    return phone;
}

/**
 * Форматирование с пробелами между каждой цифрой (для big-display карточки):
 * "79990777777" → "+7 9 9 9 0 7 7 7 7 7 7"
 */
export function formatPhoneSpaced(phone) {
    if (!phone) return '';
    const digits = String(phone).replace(/\D/g, '');
    if (digits.length === 11) {
        return '+' + digits.split('').join(' ');
    }
    return phone;
}